/**
 * 防抖工具函数
 * 在指定延迟时间内只执行最后一次调用，常用于输入框搜索等高频触发场景
 *
 * @param {Function} fn 需要防抖的函数
 * @param {number} [delay=300] 延迟时间（毫秒），默认 300ms
 * @returns {Function} 防抖处理后的函数
 */
export function debounce(fn, delay = 300) {
  let timer = null
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
      timer = null
    }, delay)
  }
}
